module.exports = __webpack_public_path__ + "static/media/high-mega.0d3b71fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/high-mega.jpg
// module id = 279
// module chunks = 0